import type { Client } from '@core/api/utils';
import { pipeData } from '@core/api/utils';
import { toPeloton } from './mappers';

const toPelotonUrl = (id: string) => `/api/peloton/${id}`;

export const fetchPeloton = (api: Client, pelotonId: string) =>
  api.get(toPelotonUrl(pelotonId)).then(pipeData(toPeloton));
